export default "/images/3b61cf22d3a74972031658de707fbaee.avif";